import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './SegmentedControl.css';

interface SegmentedControlProps {
  label: string;
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({ label, value, onChange }) => {
  const { t } = useLanguage();

  // Get slider position: 0 = Yes, 1 = No, 2 = Don't know
  const getSliderIndex = () => {
    if (value === true) return 0;
    if (value === false) return 1;
    return 2;
  };

  // Get color class for slider
  const getSliderColor = () => {
    if (value === true) return 'yes';
    if (value === false) return 'no';
    return 'unknown';
  };

  return (
    <div className="segmented-control">
      <span className="segmented-label">{label}</span>
      <div className="segmented-buttons">
        <div
          className={`segment-slider ${getSliderColor()}`}
          style={{ transform: `translateX(${getSliderIndex() * 100}%)` }}
        />
        <button
          type="button"
          className={`segment ${value === true ? 'active yes' : ''}`}
          onClick={() => onChange(true)}
        >
          {t('facilities.yes')}
        </button>
        <button
          type="button"
          className={`segment ${value === false ? 'active no' : ''}`}
          onClick={() => onChange(false)}
        >
          {t('facilities.no')}
        </button>
        <button
          type="button"
          className={`segment ${value === null ? 'active unknown' : ''}`}
          onClick={() => onChange(null)}
        >
          {t('facilities.dontKnow')}
        </button>
      </div>
    </div>
  );
};

export default SegmentedControl;
